import { toDisplayAmountNoDecimal } from '@web/components/utils/format'

export const DONOR_PAYS_AMOUNT_TOKEN = '{amount}'

export const DEFAULT_DONOR_PAYS_WORDING = `I’d like to add a bit extra to help cover fees. This will add ${DONOR_PAYS_AMOUNT_TOKEN} to your donation.`

export const formatDonorPaysWording = (wording: string | null | undefined, amount: number) => {
  const template = wording?.trim() ? wording : DEFAULT_DONOR_PAYS_WORDING

  return template.split(DONOR_PAYS_AMOUNT_TOKEN).join(`$${toDisplayAmountNoDecimal(amount)}`)
}
